import { ref, type Directive, type DirectiveBinding } from 'vue';

export interface MountedElement {
  el: HTMLElement;
  name: DirectiveBinding<string>;
}

export const mountedElements = ref<MountedElement[]>([]);

const vMounted: Directive<HTMLElement, string> = {
  mounted(el: HTMLElement, binding: DirectiveBinding<string>) {
    mountedElements.value.push({
      el,
      name: binding,
    });
  },
  unmounted(el: HTMLElement) {
    mountedElements.value = mountedElements.value.filter((e) => e.el !== el);
  },
};

export default vMounted;
